import { AxiosResponse } from 'axios';
import deviceAxios from '../../../../utils/axios/device.axios';
import { DEVICE_INFO_API_URL } from '../../../../config';

const tryToFetchReconciles = (): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/configs/templates`;
    return deviceAxios.get<any>(url);
};

const tryToFetchRules = (): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/configs/rules`;
    return deviceAxios.get<any>(url);
};

const tryToUpdateRules = (data: any): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/configs/rules`;
    return deviceAxios.put<any>(url, data);
};

const tryToFetchAdminStats = (): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/cash-reconciliation/admin-dashboard/summary`;
    return deviceAxios.put<any>(url);
};

const tryToFetchExecutiveStats = (data: any): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/recon-analytics/executive-transactions`;
    return deviceAxios.put<any>(url, data);
};

const tryToFetchAdminDiscrepancies = (
    pageNumber: number,
    pageSize: number,
    filters?: string,
): Promise<AxiosResponse<any>> => {
    const url = filters
        ? `${DEVICE_INFO_API_URL}/cash-reconciliation/discrepancies-overview?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${DEVICE_INFO_API_URL}/cash-reconciliation/discrepancies-overview?page=${pageNumber}&size=${pageSize}`;
    return deviceAxios.put<any>(url);
};

const tryToFetchAdminTemplateFiles = (
    pageNumber: number,
    pageSize: number,
    filters?: string,
): Promise<AxiosResponse<any>> => {
    const url = filters
        ? `${DEVICE_INFO_API_URL}/cash-reconciliation/files-templates?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${DEVICE_INFO_API_URL}/cash-reconciliation/files-templates?page=${pageNumber}&size=${pageSize}`;
    return deviceAxios.put<any>(url);
};

const tryToFetchFailedRecon = (
    pageNumber: number,
    pageSize: number,
    filters?: string,
): Promise<AxiosResponse<any>> => {
    const url = filters
        ? `${DEVICE_INFO_API_URL}/cash-reconciliation/failed-recon-jobs?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${DEVICE_INFO_API_URL}/cash-reconciliation/failed-recon-jobs?page=${pageNumber}&size=${pageSize}`;
    return deviceAxios.put<any>(url);
};

const tryToFetchRuleLogs = (
    pageNumber: number,
    pageSize: number,
    filters?: string,
): Promise<AxiosResponse<any>> => {
    const url = filters
        ? `${DEVICE_INFO_API_URL}/configs/rules/logs?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${DEVICE_INFO_API_URL}/configs/rules/logs?page=${pageNumber}&size=${pageSize}`;
    return deviceAxios.get<any>(url);
};

export const AdminService = {
    tryToFetchReconciles,
    tryToFetchRuleLogs,
    tryToFetchRules,
    tryToUpdateRules,
    tryToFetchAdminStats,
    tryToFetchAdminDiscrepancies,
    tryToFetchAdminTemplateFiles,
    tryToFetchFailedRecon,
    tryToFetchExecutiveStats
};